export const API_MAINTENANCE_CODE = "API_MAINTENANCE";
export const TOO_MANY_REQUESTS_CODE = "TOO_MANY_REQUESTS";
export const PLATO_ERROR_SOURCE = "plato";
export const FORBIDDEN_REQUESTED_RESOURCE_CODE = "FORBIDDEN_REQUESTED_RESOURCE";
